import { render, staticRenderFns } from "./Shifts.vue?vue&type=template&id=a71758cc&"
import script from "./Shifts.vue?vue&type=script&lang=js&"
export * from "./Shifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports